var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 23,
    fill: "none",
    viewBox: "0 0 37 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.167 22.75h32.666c1.123 0 2.042-.844 2.042-1.875S35.956 19 34.833 19H2.167c-1.123 0-2.042.844-2.042 1.875s.919 1.875 2.042 1.875m0-9.375h32.666c1.123 0 2.042-.844 2.042-1.875s-.919-1.875-2.042-1.875H2.167c-1.123 0-2.042.844-2.042 1.875s.919 1.875 2.042 1.875M.125 2.125C.125 3.156 1.044 4 2.167 4h32.666c1.123 0 2.042-.844 2.042-1.875S35.956.25 34.833.25H2.167C1.044.25.125 1.094.125 2.125",
    clipRule: "evenodd"
  })));
};
export default SvgMenu;